export const baumagazinFooterData = [
  {
    type: "FooterHeroColumn",
    title: "B_I baumagazin",
    link: "/fachzeitschriften/baumagazin",
    youtube: "",
    paragraph:
      "Online-Portal und Fachzeitschrift für Hoch-, Tief- und Straßenbau sowie Baupolitik.",
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Kontakt",
    link: "/ueber-uns/kontakt#contact-fachzeitschriften",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/ueber-uns/redaktion",
        label: "Redaktion",
      },
      {
        type: "FooterLink",
        link: "/ueber-uns/media#mediadata-baumagazin",
        label: "Mediadaten",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Mehr lesen",
    link: "/fachzeitschriften",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/fachzeitschriften/galabau",
        label: "B_I galabau",
      },
      {
        type: "FooterLink",
        link: "/fachzeitschriften/umweltbau",
        label: "B_I umweltbau",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Mehr rausholen",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/ausschreibungen/bauleistungen",
        label: "Bau-Ausschreibungen finden",
      },
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/ausschreibungen/region/bayern",
        label: "Ausschreibungen Bayern",
      },
    ],
  },
]
